import React from "react";
import { useTranslation } from "react-i18next";

const LoadingState = () => {
    const { t } = useTranslation();
    return (
        <div className="h-full flex items-center justify-center text-sm text-gray-500">
            {t("fetching")}
        </div>
    );
};

export default LoadingState;

